import { axiosClient } from '../axiosClient';

export interface DashboardMetrics {
  totalDevices: number;
  activeDevices: number;
  totalErrors: number;
  criticalErrors: number;
  totalUsers: number;
  activeUsers: number;
  unresolvedErrors: number;
  avgResponseTime: number;
}

export const getDashboardMetrics = async (): Promise<DashboardMetrics> => {
  try {
    const response = await axiosClient.get('/dashboard/metrics');
    const data = response.data;

    return {
      totalDevices: data.total_devices,
      activeDevices: data.active_devices,
      totalErrors: data.total_errors || 0,
      criticalErrors: data.critical_errors,
      totalUsers: data.total_users,
      activeUsers: data.active_users,
      unresolvedErrors: data.unresolved_errors,
      avgResponseTime: data.avg_response_time_ms || 0,
    };
  } catch (error) {
    console.error('Failed to fetch dashboard metrics:', error);
    throw error;
  }
};

interface DeviceActivityItem {
  date: string;
  peak_daily: number;
  average_daily: number;
}

export const getDeviceActivity = async (
  period: '24h' | 'yesterday' | '7d' | '30d' | '3m' = '7d'
) => {
  try {
    const response = await axiosClient.get<DeviceActivityItem[]>('/dashboard/device-activity', {
      params: { period },
    });
    const data = response.data;

    return data.map((item) => ({
      date: item.date,
      peak: item.peak_daily,
      average: item.average_daily,
    }));
  } catch (error) {
    console.error('Failed to fetch device activity:', error);
    throw error;
  }
};

export const getErrorsByType = async () => {
  try {
    const response = await axiosClient.get('/dashboard/errors-by-type');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch errors by type:', error);
    throw error;
  }
};

interface RecentDeviceItem {
  id: number;
  status: string;
  user: string;
  user_id: number;
  device: string;
  platform: string;
  app_version: string;
  last_activity: string;
}

export const getRecentDevices = async (limit = 10) => {
  try {
    const response = await axiosClient.get<RecentDeviceItem[]>('/dashboard/recent-devices', {
      params: { limit },
    });
    const data = response.data;

    const devices = data.map((item) => {
      const [model, ...platformParts] = item.device.split(' ');
      const platform = platformParts.join(' ');

      return {
        id: item.id.toString(),
        status: item.status,
        userName: item.user,
        userId: item.user_id.toString(),
        model: model,
        platform: item.platform,
        appVersion: item.app_version,
        lastActivity: item.last_activity,
        sessions: 0,
        errors: 0,
        crashes: 0,
        osVersion: platform,
        fingerprint: '',
      };
    });

    return { devices };
  } catch (error) {
    console.error('Failed to fetch recent devices:', error);
    throw error;
  }
};
